<mat-icon (click)="generate();" class="iban" title="Generate IBAN" *ngIf="isLowerEnvironment">
    input
</mat-icon>